export default "__VITE_ASSET__DDYpMNes__"